import AttachmentAssignees, { Props } from './AttachmentAssignees';

export default AttachmentAssignees;
export { type Props };